const detalModelTypes = {
  area: "area",
  department: "department"
} as const

export { detalModelTypes }
